import React from 'react'
import DiscretionaryRenewalTaskList from '../../../features/gmap/DiscretionaryRenewalTaskList/DiscretionaryRenewalTaskList'

const GmapDiscretionaryRenewalTaskList = () => {
    return (
        <DiscretionaryRenewalTaskList />
    )
}

export default GmapDiscretionaryRenewalTaskList